import { ROUTES } from '../../../constants/routes';

/**
 * Absolute URL for **public** match results (`GET /match/:matchResultsId` on the API).
 * Uses `NEXT_PUBLIC_API_URL` when set so shared links hit API Gateway, not the Next app.
 */
export function getMatchResultsPublicUrl(
  matchResultsId: string | null | undefined,
): string {
  const id = matchResultsId?.trim();
  const base =
    typeof process !== 'undefined'
      ? (process.env.NEXT_PUBLIC_API_URL ?? '').replace(/\/$/, '')
      : '';
  if (id && base) {
    return `${base}/match/${encodeURIComponent(id)}`;
  }
  if (typeof window !== 'undefined' && id) {
    return `${window.location.origin}/match/${encodeURIComponent(id)}`;
  }
  if (id) {
    return `/match/${encodeURIComponent(id)}`;
  }
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${ROUTES.matchingPoc}`;
  }
  return ROUTES.matchingPoc;
}

/**
 * @deprecated Use {@link getMatchResultsPublicUrl} with `matchResultsId` from POST /match.
 */
export function getMatchResultsSharePlaceholderUrl(): string {
  return getMatchResultsPublicUrl(undefined);
}
